// The browser's built-in "Please fill out this field" bubble is picked from
// the *browser's* own UI language, not this page's `lang="pt-BR"` — an
// admin whose Chrome/Firefox is set to English sees English messages on an
// otherwise all-Portuguese screen (book/genre name fields, report date
// range). Overriding via setCustomValidity keeps every native
// `required`/`min`/`max` field's message in Portuguese regardless of the
// browser's locale.
function messageFor(field) {
  const { validity } = field

  if (validity.valueMissing) return "Preencha este campo."
  if (validity.typeMismatch) return field.type === "email" ? "Informe um e-mail válido." : "Valor inválido."
  if (validity.tooShort) return `Use pelo menos ${field.minLength} caracteres.`
  if (validity.tooLong) return `Use no máximo ${field.maxLength} caracteres.`
  if (validity.rangeUnderflow) return `O valor deve ser maior ou igual a ${field.min}.`
  if (validity.rangeOverflow) return `O valor deve ser menor ou igual a ${field.max}.`
  if (validity.stepMismatch || validity.badInput) return "Valor inválido."
  if (validity.patternMismatch) return "Formato inválido."

  return "Valor inválido."
}

export function installNativeValidationMessages() {
  // "invalid" doesn't bubble — must listen on the capture phase.
  document.addEventListener("invalid", (event) => {
    const field = event.target
    if (!("setCustomValidity" in field)) return
    field.setCustomValidity(messageFor(field))
  }, true)

  // A non-empty custom message permanently fails validation until cleared —
  // reset it on every edit so a corrected value can pass again.
  document.addEventListener("input", (event) => {
    if ("setCustomValidity" in event.target) event.target.setCustomValidity("")
  }, true)
}
